<template>
    <!-- 申请记录 -->
    <div class="sqjl">
        <van-nav-bar
        title=""
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
        />

        

        <div class="top">
            <div class="btn1box">
                <div class="pes">
                    <div class="txt">配额数：<span style="color: #FD4A46;">{{infodata.usableCount || 0}}</span></div>
                </div>
            </div>
            <div class="middle"></div>
            <div class="btn2box">
                <div class="yqbs">
                    <div class="txt">
                        已申报数：<span style="color: #FD4A46;">{{infodata.usedCount || 0}}</span> 
                    </div>
                </div>
            </div>
        </div>

        <van-empty description="暂无数据" v-show="nodata" />

        <div class="main" v-if="dataList.length > 0">
            <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="getmore"
            >
            <div class="infobox" v-for="(item,index) in dataList" :key="index">
                <div class="yyrq">
                    <div class="left">
                        <div class="yy">预约日期：</div>
                        <div class="rq">{{item.date || "" }}</div>
                    </div>
                    <div class="right">申请编号：{{item.serialNumber}}</div>
                </div>
                <div class="sqdw" data-flex>
                    <div class="sq">申请单位：</div>
                    <div class="dw">{{item.applicantName}}</div>
                </div>
                <div class="ldxm" data-flex>
                    <div class="ld">领队姓名：</div>
                    <div class="xm">{{item.realname}}</div>
                </div>
                <div class="yyrs" data-flex>
                    <div class="yy">预约人数：</div>
                    <div class="rs">{{item.population}}</div>
                </div>
                <div class="sbrq" data-flex>
                    <div class="srq">
                        <div class="yy">申报日期：</div>
                        <div class="rq">{{item.ctime}}</div>
                    </div>
                    <div class="ewm-btn" data-flex="cross:center main:center" @click="showImg(item)">二维码</div>
                </div>
            </div>
            </van-list>
            
        </div>

        <div class="bg" v-show="showqr">
            <div class="qrbox">
            <div class="qrtitle">二维码</div>
            <div ref="qrcode" class="qrcode">
                <img :src="codedata | qiniuImageView(1, 160, 160)"  >

            </div>
            <div class="dhx" v-show="this.ishe == 1">待核销</div>
            <div class="dhx" v-show="this.ishe == 2">已核销</div>
            <div class="qrbtn" @click="showqr= false">
                <div class="qrbtn-txt" >关闭</div>
            </div>
            </div>
        </div>


    </div>
  
</template>

<script>
import mix1 from '@/mixins/page'
import { uiShowLoading, uiHideLoading, uiAlert, uiConfirm } from '@/utils/ui'
import { List, NavBar, Empty } from 'vant'
export default {
    name:"sqjl",
    mixins: [mix1],
    components: {
        [List.name]: List,
        [NavBar.name]: NavBar,
        [Empty.name]: Empty,
    },
    created(){
        this.getList()
        this.getUserInfo()
    },
    data() {
        return{
            infodata:{},
            dataList:[
            //     {
            //     yyrq:"2024-11-11",
            //     sqdw:"XX名称",
            //     ldxm:"徐桂英",
            //     yyrs:10,
            //     sbrq:"2024-11-11"
            // },
            // {
            //     yyrq:"2024-11-11",
            //     sqdw:"XX名称",
            //     ldxm:"薛超",
            //     yyrs:10,
            //     sbrq:"2024-11-11"
            // },
            // {
            //     yyrq:"2024-11-11",
            //     sqdw:"于明",
            //     ldxm:"魏磊",
            //     yyrs:10,
            //     sbrq:"2024-11-11"
            // },
            ],
            loading: false,//是否加载更多
            finished: false,//后端是否已经没有数据了
            pagenum:1,
            pageSize:10,
            codedata:"",
            showqr:false,
            ishe:false,
            nodata:false,
        }
    },
    methods:{
        onClickLeft(){
            this.$router.go(-1);
        },
        async getUserInfo(){
            const promise = this.apiGet('my.userInfo')
            let apiResult = null

            try {
                apiResult = await promise
            } catch (ex) {
                apiResult = null
            }

            if (this.isEmpty(apiResult)) {
                return
            }

            this.infodata = apiResult.obj
            console.log("this.infodata=>",this.infodata);
        },
        async getList(){
            uiShowLoading();
            let data = {};
            data.page = this.pagenum;
            data.pageSize = this.pageSize;
            data.type = 1;//申报记录
            console.log("请求data：",data);
            const promise = this.apiGet('yy.postForm',data);
            let apiResult = null
            try {
                apiResult = await promise
            } catch (ex) {
                apiResult = null
            }
            if (this.isEmpty(apiResult)) {
                console.log("空了");
                this.loading = false;
                this.finished = true;
                return
            }

            if(apiResult.list.length == 0){
                this.nodata = true;
            }

            this.dataList = apiResult.list;
            this.loading = false;
            console.log("this.dataList=>",this.dataList);
            uiHideLoading();
        },

       async getmore(){
            this.pagenum++;
            let data2 = {};
            data2.page = this.pagenum;
            data2.pageSize = this.pageSize;
            data2.type = 1;//申报记录
            const promise = this.apiGet('yy.postForm',data2)
            let apiResult = null
            try {
                apiResult = await promise
            } catch (ex) {
                apiResult = null
            }
            if (this.isEmpty(apiResult)) {
                console.log("空的");
                this.loading = false;
                this.finished = true;
                // return
            }
            this.dataList = this.dataList.concat(apiResult.list);
            if(apiResult.list.length < 10){
                console.log("返回的数据小于10个");
                    // this.loading = false;
                    this.finished = true;
                }
            console.log("this.dataList=>",this.dataList);
             // 加载状态结束
            // this.finished = true;
            this.loading = false;
        },

        showImg(x){
            if(x.verificationCode != "" && x.verificationCode != undefined && x.verificationCode != null ){
                this.codedata = x.verificationCode;
                this.ishe = x.status;
                this.showqr = true;
            }else{
                this.getdetail(x.id)
            }
        },

       async getdetail(c){
        let y = c;
        let data = {id:y}
        const promise = this.apiGet('hexiaoListXq',data)
        let apiResult = null
            try {
                apiResult =  await promise
            } catch (ex) {
                apiResult = null
            }
            if (this.isEmpty(apiResult)) {
                console.log("进入判空了");
                return;
            }
            console.log("apiResult",apiResult);
            this.codedata = apiResult.obj.verificationCode;
            this.ishe = apiResult.obj.status;
            this.showqr = true;
        },
    },

}
</script>

<style lang="less" scoped>
.sqjl{
    // height: 100vh;
    .top{
        width: 750px;
        height: 88px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        margin-bottom: 20px;
        .btn1box{
            width: 375px;
            height: 88px;
            display: flex;
            align-items: center;
            justify-content: center;
            .pes{
                width: 244px;
                height: 62px;
                background: #FFFFFF;
                border-radius: 31px 31px 31px 31px;
                border: 1px solid #FD4A46;
                display: flex;
                align-items: center;
                justify-content: center;
                .txt{
                    width: 162px;
                    height: 40px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 40px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                }
            }
        }
        .middle{
        height: 43px;
        width: 0px;
        border: 1px solid #C2C2C2;
        }
        .btn2box{
            width: 375px;
            height: 88px;
            display: flex;
            align-items: center;
            justify-content: center;
            .yqbs{
                width: 244px;
                height: 62px;
                background: #FFFFFF;
                border-radius: 31px 31px 31px 31px;
                border: 1px solid #FD4A46;
                display: flex;
                align-items: center;
                justify-content: center;
                .txt{
                    width: 174px;
                    height: 40px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 40px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                }
            }
        }
    }
    
    .main{
        .infobox{
            margin: 0 auto;
            border: 1px solid transparent;
            width: 710px;
            height: 400px;
            background: #FFFFFF;
            border-radius: 15px 15px 15px 15px;
            margin-bottom: 10px;
            padding: 8px;
            box-sizing: border-box;
            .yyrq{
                margin-left: 20px;
                margin-top: 30px;
                display: flex;
                justify-content: space-between;
                .left{
                    display: flex;
                    .yy{
                        // width: 308px;
                        height: 40px;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 12px;
                        color: #030303;
                        line-height: 40px;
                        text-align: left;
                        font-style: normal;
                        text-transform: none;
                    }
                    .rq{
                        height: 40px;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 12px;
                        color: #030303;
                        line-height: 40px;
                        text-align: left;
                        font-style: normal;
                        text-transform: none;
                    }
                    
                }
                .right{
                    height: 40px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 12px;
                    color: #030303;
                    line-height: 40px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                }
                
            }
            .sqdw{
                margin-left: 20px;
                margin-top: 24px;
                .sq{
                    // width: 140px;
                    height: 40px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: bold;
                    font-size: 14px;
                    color: #030303;
                    line-height: 40px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                }
                .dw{
                    height: 40px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: bold;
                    font-size: 14px;
                    color: #030303;
                    line-height: 40px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                }
            }
            .ldxm{
                margin-left: 20px;
                margin-top: 18px;
                .ld{
                    height: 40px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: bold;
                    font-size: 14px;
                    color: #030303;
                    line-height: 40px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                }
                .xm{
                    height: 40px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: bold;
                    font-size: 14px;
                    color: #030303;
                    line-height: 40px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                }
            }
            .yyrs{
                margin-left: 20px;
                margin-top: 18px;
                .yy{
                    height: 40px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: bold;
                    font-size: 14px;
                    color: #030303;
                    line-height: 40px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                }
                .rs{
                    // width: 43px;
                    height: 50px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: bold;
                    font-size: 18px;
                    color: #FD4A46;
                    line-height: 50px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                }
            }
            .sbrq{
                margin-left: 20px;
                margin-top: 34px;
                display: flex;
                justify-content: space-between;
                .srq{
                    .sb{
                        // width: 308px;
                        height: 40px;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #030303;
                        line-height: 40px;
                        text-align: left;
                        font-style: normal;
                        text-transform: none;
                    }
                    .rq{
                        height: 40px;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #030303;
                        line-height: 40px;
                        text-align: left;
                        font-style: normal;
                        text-transform: none;
                    }
                }

                .ewm-btn {
                        width: 178px;
                        height: 68px;
                        background: #ffffff;
                        border-radius: 34px 34px 34px 34px;
                        border: 2px solid #13a6fa;
                        color: #13a6fa;
                }
                
               
            }
            }
    }

}

.bg {
    margin: 0 auto;
    width: 100vw;
    height: 100vh;
    background-color: rgba(70, 70, 70, 0.3);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    // justify-content: center;
    .qrbox{
      margin: 0 auto;
      display: flex;
      // align-items: center;
      flex-wrap: wrap;
      justify-content: center;
      width: 632px;
      height: 751px;
      background: #FFFFFF;
      border-radius: 15px 15px 15px 15px;
      .qrtitle{
        width: 632px;
        height: 46px;
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 16px;
        color: #000000;
        line-height: 46px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        text-align: center;
        margin-top: 66px;
      }
      .qrcode{
        margin-top: 48px;
      }
      .dhx{
        width: 632px;
        height: 46px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #FF0B0B;
        line-height: 46px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
      .qrbtn{
        width: 441px;
        height: 88px;
        background: #FD4A46;
        border-radius: 44px 44px 44px 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        .qrbtn-txt{
          // width: 64px;
          height: 46px;
          font-family: PingFang SC, PingFang SC;
          font-weight: bold;
          font-size: 16px;
          color: #FFFFFF;
          line-height: 46px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
      }
    }
}





</style>